import { formatMarkdownContent } from '../../../common/TipTapEditor';
import { renderLinks } from '../../../pages/Check-In/utils';
import { TicketUpdate } from '../types';

interface TicketUpdateDetailViewProps {
  item: TicketUpdate;
}

export function TicketUpdateDetailView({
  item,
}: TicketUpdateDetailViewProps): JSX.Element {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-2">Progress</h3>
        <p className="text-gray-700 whitespace-pre-wrap">
          {formatMarkdownContent(item.description)}
        </p>
      </div>

      {item.blockers && (
        <div>
          <h3 className="text-lg font-semibold mb-2">Blockers/Concerns</h3>
          <p className="text-gray-700 whitespace-pre-wrap">
            {formatMarkdownContent(item.blockers)}
          </p>
        </div>
      )}

      {item.progress && (
        <div>
          <h3 className="text-lg font-semibold mb-2">Progress %</h3>
          <p className="text-gray-700">
            {item.progress?.current || 0}% (Previously{' '}
            {item.progress?.previous || 0}%)
          </p>
        </div>
      )}

      {item.wipLinks && (
        <div>
          <h3 className="text-lg font-semibold mb-2">WIP Materials</h3>
          <p className="text-gray-700 break-words">
            {renderLinks(item.wipLinks)}
          </p>
        </div>
      )}
    </div>
  );
}
